
/* injects from baggage-loader */

'use strict';

import AccountComponent from './account.component';
import './account.scss';

// Load child states
import AccountHomePageModule from './home/account.home.module';
import AccountDocumentsPageModule from './documents/account.documents.module';
import AccountProfilePageModule from './profile/account.profile.module';
import AccountChangePasswordPageModule from './change-password/account.change-password.module';
import AccountBanksAccountsPageModule from './bank-accounts/account.bank-accounts.module';
import AccountAddNewBankAccountPageModule from './add-new-bank-account/account.add-new-bank-account.module';

const AccountPageModule = angular.module('account-module', [
  'ui.router',

  // Child states
  AccountHomePageModule.name,                 // Home (investments)
  AccountDocumentsPageModule.name,            // Documents
  AccountProfilePageModule.name,              // Profile (edit)
  AccountChangePasswordPageModule.name,       // Change Password
  AccountBanksAccountsPageModule.name,        // Manage bank Accounts
  AccountAddNewBankAccountPageModule.name,    // Add new bank account

])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account', {
        url: '/account',
        component: 'account',
        // Requires valid login to visit
        protected: true,
        // Abstract parent of children states, cannot be visited directly
        abstract: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          profile: function (Profiles) {
            try {
              return Profiles.fetchOwn();
            } catch (err) {
              throw err;
            }
          }
        }
      });
  })
  .component('account', new AccountComponent());

export default AccountPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/account.module.js